import React, { FC } from 'react';
import classNames from 'classnames';

import { ELEMENTS } from 'utils/constants';

import Container from 'layout/Container';
import TopFooter from 'layout/Footer/TopFooter';
import BottomFooter from 'layout/Footer/BottomFooter';
import BackToTopButton from 'layout/Footer/BackToTopButton';
import References from 'layout/Footer/References';
import FooterBottomBanner from 'layout/Footer/FooterBottomBanner';
import IconFeatureList from 'components/IconFeatureList';

import DangerouslySetInnerHtml from 'common/DangerouslySetInnerHtml';
import { IPropsFooter } from './model';
import './Footer.scss';
import './ShadowFooter.scss';

const Footer: FC<IPropsFooter> = ({
  footer,
  footer: {
    copyRight,
    ariaLabelBackToTopButton,
    referencesBlock,
    footerBottomBanner,
    iconsList,
    footerBottomText,
    footerBottomBannerSticky,
  },
}) => (
  <footer
    className={classNames('footer', {
      'footer--pb': footerBottomBannerSticky,
    })}
    data-test="footer"
    id={ELEMENTS.FOOTER_ID}
  >
    <div className="footer-main-content">
      <Container className="footer-container">
        <BackToTopButton ariaLabelBackToTopButton={ariaLabelBackToTopButton} />
        <TopFooter footer={footer} />
        <References referencesBlock={referencesBlock} />
        <DangerouslySetInnerHtml className="footer__bottom-text" html={footerBottomText} />
        <BottomFooter copyRight={copyRight} />
      </Container>
    </div>
    {footerBottomBanner?.length ? (
      <div
        className={classNames('footer-secondary-content', {
          'footer-secondary-content--sticky': footerBottomBannerSticky,
        })}
      >
        <Container className="footer-secondary-container">
          <FooterBottomBanner footerBottomBanner={footerBottomBanner} />
        </Container>
      </div>
    ) : null}
    {iconsList ? <IconFeatureList iconsList={iconsList} /> : null}
  </footer>
);

export default Footer;
